// extracted by mini-css-extract-plugin
export default {"burgerWrapper":"Burger_burgerWrapper__K+7tZ","open":"Burger_open__iGlRS","invert":"Burger_invert__31yPI"};